// FIXME: Is not allowed in node list?
import React from 'react'
import { PropTypes } from 'prop-types'
import { useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import ImageSearchIcon from '@material-ui/icons/ImageSearch'

import { setNodeProperties } from '../../../../redux/nodes'

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
        padding: '5px',
    },
}))

const SideBar = ({ node }) => {
    const classes = useStyles()
    const dispatch = useDispatch()

    const onPropertyChangedHandlerBuilder = (property) => (event) => {
        dispatch(
            setNodeProperties({
                nodeId: node.id,
                properties: {
                    type: property,
                    value: event.target.value || '',
                },
            })
        )
    }

    const getProperty = (key, def) => {
        return node.properties[key] || def
    }

    return (
        <div className={classes.root}>
            <ImageSearchIcon />
            <TextField
                label="Para"
                type="email"
                value={getProperty('to', '')}
                onChange={onPropertyChangedHandlerBuilder('to')}
                fullWidth
            />
            <TextField
                label="Asunto"
                value={getProperty('subject', '')}
                onChange={onPropertyChangedHandlerBuilder('subject')}
                fullWidth
            />
            <TextField
                label="Mensaje"
                value={getProperty('body', '')}
                onChange={onPropertyChangedHandlerBuilder('body')}
                rows={4}
                rowsMax={20}
                multiline
                fullWidth
            />
        </div>
    )
}

SideBar.propTypes = {
    node: PropTypes.shape({
        id: PropTypes.string,
        type: PropTypes.string,
        position: PropTypes.shape({
            x: PropTypes.number,
            y: PropTypes.number,
        }),
        ports: PropTypes.array,
        properties: PropTypes.object,
        size: PropTypes.shape({
            width: PropTypes.number,
            height: PropTypes.number,
        }),
    }).isRequired,
}

export default SideBar
